<template>
  <li class="device-list-item" :class="itemStyles">
    <div class="device">
      <div class="device-info">
        <div class="name">
          {{ device.name }}
        </div>

        <div class="installation-date">
          {{ $t("installedDevices.installed") }} {{ device.created_ts | localDate }}
        </div>

        <div v-if="device.last_seen" class="last-used">
          {{ $t("installedDevices.lastUsed") }} {{ device.last_seen | timeAgo }}
        </div>

        <div v-if="!showRemovingAlert"
             class="remove-btn"
             @click="onDeviceRemoveClick">
          <icon-cross width="20"
                      height="20"
                      class="cross" />
          {{ $t("installedDevices.removeDevice") }}
        </div>
      </div>

      <component :is="getDeviceIcon"
                 iconColor="#ccc"
                 class="icon" />
    </div>
    <device-removing-alert v-if="showRemovingAlert"
                           @confirm="onRemovingConfirm"
                           @cancel="onRemovingDecline" />
  </li>
</template>

<script>
  import DeviceRemovingAlert from './DeviceRemovingAlert.vue'
  import platformIcons from '@/constants/platformIcons.js'

  export default {
    props: {
      device: {
        type: Object,
        required: true
      }
    },

    components: {
      DeviceRemovingAlert
    },

    data() {
      return {
        showRemovingAlert: false
      }
    },

    methods: {
      onDeviceRemoveClick() {
        this.showRemovingAlert = true
      },

      onRemovingConfirm() {
        this.$emit('removeDevice', this.device.id)
        this.showRemovingAlert = false
      },

      onRemovingDecline() {
        this.showRemovingAlert = false
      }
    },

    computed: {
      itemStyles() {
        return {
          'removing-alert': this.showRemovingAlert
        }
      },

      getDeviceIcon() {
        if (platformIcons[this.device.platform]) {
          return platformIcons[this.device.platform]
        }

        return platformIcons['ios']
      }
    }
  }
</script>

<style lang="scss" scoped>
  .device-list-item {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 20px;

    .device {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .device-info {
        .name {
          color: map-get($colors, primary);
          font-size: 24px;
          font-weight: bold;
        }

        .installation-date {
          padding-top: 5px;
        }

        .last-used {
          padding-top: 5px;
        }

        .remove-btn {
          color: #b9b9b9;
          margin: 10px 0 20px;
          cursor: pointer;

          .cross {
            position: relative;
            bottom: -5px;
          }
        }
      }

      .icon {
        width: 50px;
        height: 50px;
      }
    }
  }

  .removing-alert {
    background: lighten(#f25b5b, 25%);
    padding: 10px;
  }
</style>
